/**
 * 检测字符串是否为数字捕获正则
 */
export const numberRegex = /^[0-9]+$/;
/**
 * 检测字符串是否为有效的邮件地址捕获正则
 */
export const emailRegex = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
/**
 * 检测字符串是否为decimal(18,2)
 */
export const decimalRegex = /^\d{1,18}(\.\d{1,2})?$/;
/**
 * 检测手机号
 */
export const mobileRegex = /^[1][0,1,2,3,4,5,6,7,8,9][0-9]{9}$/;
/**
 * 身份证简单验证：身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
 */
export const idCardRegex = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;



// WEBPACK FOOTER //
// ./src/constant/regexExp.js